"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponAPIDetailResponseScheme = exports.CouponAPIListResponseScheme = void 0;
var zod_1 = require("zod");
var CouponAPIProductItemBadgeScheme = zod_1.z.object({
    title: zod_1.z.string().nullable(),
    weight: zod_1.z.number(),
    background: zod_1.z.string().nullable(),
});
var CouponAPIProductItemScheme = zod_1.z.object({
    productItemType: zod_1.z.string(),
    data: zod_1.z.object({
        // 상품
        no: zod_1.z.number(),
        title: zod_1.z.string(),
        desc: zod_1.z.string().optional(),
        position: zod_1.z.object({
            address: zod_1.z.object({
                desc: zod_1.z.string().nullable().optional(),
            }),
            latitude: zod_1.z.number().optional(),
            longitude: zod_1.z.number().optional(),
        }),
        price: zod_1.z.object({
            origin: zod_1.z
                .object({
                amount: zod_1.z.number(),
            })
                .nullable()
                .optional(),
            discount: zod_1.z
                .object({
                amount: zod_1.z.number(),
                rate: zod_1.z.number().optional().nullable(),
                exposeRate: zod_1.z.boolean().optional(),
                badgeTitle: zod_1.z.string().optional().nullable(), // 할인률 뱃지명 e.g. '야놀자특가'
            })
                .nullable()
                .optional(),
            coupon: zod_1.z
                .object({
                amount: zod_1.z.number().nullable().optional(),
                exposeAmount: zod_1.z.boolean().optional(),
                condition: zod_1.z.array(zod_1.z.string()).optional().nullable(),
                badgeTitle: zod_1.z.string().optional().nullable(), // 할인률 뱃지명 e.g. '야놀자특가'
                // lowStock: z.string().nullable().optional(),
            })
                .nullable()
                .optional(),
        }),
        image: zod_1.z.object({
            cover: zod_1.z.string().optional().nullable(),
        }),
        badgesInfo: zod_1.z
            .object({
            fullRefund: zod_1.z.array(CouponAPIProductItemBadgeScheme).nullable().optional(),
            todayUsable: zod_1.z.array(CouponAPIProductItemBadgeScheme).nullable().optional(),
            lowestPrice: zod_1.z.array(CouponAPIProductItemBadgeScheme).nullable().optional(),
        })
            .nullable()
            .optional(),
        action: zod_1.z
            .object({
            app: zod_1.z.string().optional().nullable(),
            web: zod_1.z.string().optional().nullable(),
        })
            .nullable()
            .optional(),
    }),
});
var CouponItemScheme = zod_1.z.object({
    case: zod_1.z.union([zod_1.z.enum(['USABLE', 'EXPIRED', 'PENDING']), zod_1.z.string()]),
    chipTitle: zod_1.z.string(),
    chipAddTitle: zod_1.z.string().nullable().optional(),
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    discountText: zod_1.z.string(),
    usablePeriodText: zod_1.z.string().nullable().optional(),
    toDetailUrl: zod_1.z.string().nullable().optional(),
    toRelatedProduct: zod_1.z
        .object({
        link: zod_1.z.object({
            appUrl: zod_1.z.string().nullable().optional(),
            webUrl: zod_1.z.string().nullable().optional(),
        }),
        alert: zod_1.z
            .object({
            shouldShowAlert: zod_1.z.boolean(),
            alertMessage: zod_1.z.string().nullable().optional(),
        })
            .nullable()
            .optional(),
    })
        .nullable()
        .optional(),
});
exports.CouponAPIListResponseScheme = zod_1.z.object({
    totalCount: zod_1.z.number(),
    tabs: zod_1.z.array(zod_1.z.object({
        title: zod_1.z.string().nullable().optional(),
        chips: zod_1.z.array(zod_1.z.object({
            title: zod_1.z.string().nullable().optional(),
            items: zod_1.z.array(CouponItemScheme),
        })),
    })),
});
/**
 * 쿠폰 상세 정보 응답 값
 * http://cx-display-api.dev.yanolja.in/coupon/v1/user/coupon/detail?couponId=2811376
 */
exports.CouponAPIDetailResponseScheme = zod_1.z.object({
    type: zod_1.z.string(),
    couponCard: zod_1.z.object({
        id: zod_1.z.string(),
        chipAddTitle: zod_1.z.string().nullable().optional(),
        chipTitle: zod_1.z.string(),
        title: zod_1.z.string(),
        maxDiscountText: zod_1.z.string().nullable().optional(),
        discountText: zod_1.z.string(),
        usablePeriodText: zod_1.z.string().nullable().optional(),
        remainingTime: zod_1.z.string(), // e.g. 343일 8시간 40분 남음
    }),
    noticeList: zod_1.z.array(zod_1.z.string()).nullable().optional(),
    constraintList: zod_1.z.array(zod_1.z.any()).nullable().optional(),
    productList: zod_1.z.array(CouponAPIProductItemScheme).nullable().optional(),
    deniedAccommodationList: zod_1.z.array(zod_1.z.string()).nullable().optional(), // 쿠폰 사용 제한 국내숙소 리스트
});
